<template>
    <svg class="new-photo-svg" width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" >
        <circle cx="20" cy="20" r="19.5" stroke="CurrentColor"/>
        <path d="M19.4165 19.9167H19.9165V19.4167V14.6667H20.0832V19.4167V19.9167H20.5832H25.3332V20.0834H20.5832H20.0832V20.5834V25.3334H19.9165V20.5834V20.0834H19.4165H14.6665V19.9167H19.4165Z" fill="#ACACAC" stroke="CurrentColor"/>
    </svg>
</template>

<script>
    export default {
        name: "SVGPhotoAddNew"
    }
</script>

<style scoped>

</style>
